import { useCallback } from "react";
import axios from "axios";

import useCopilotStore from "@/store/copilotStore";

export const useFileUpload = () => {
  const copilotStore = useCopilotStore();
  const uploadAttachment = useCallback(
    async (file: any, fileIndex: any, setFileStates: any) => {
      const formData = new FormData();
      formData.append("files", file);

      try {
        const accessToken = localStorage.getItem("accessToken");
        const userInfo = JSON.parse(localStorage?.getItem("user_data") ?? "{}");
        const uuid = userInfo.id;

        formData.append("project_name", "copilot");
        formData.append("user_id", uuid);
        formData.append("doc_type", "-");
        formData.append("file_types", file?.type || "pdf");

        const response = await axios.post(
          `${import.meta.env.VITE_API_URL}/kb-documents-upload`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent: any) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );

              setFileStates((prevFileStates: any) => {
                return prevFileStates?.map((fileState: any, index: any) => {
                  if (index === fileIndex) {
                    return { ...fileState, progress: percentCompleted };
                  }
                  return fileState;
                });
              });
            },
          }
        );

        if (response.status === 200) {
          const docUrl =
            response.data.data.at(0).doc_url || response?.data?.data?.doc_url;
          if (docUrl)
            setFileStates((prevFileStates: any) => {
              return prevFileStates?.map((fileState: any, index: any) => {
                if (index === fileIndex) {
                  return {
                    ...fileState,
                    progress: 100,
                    uploaded: true,
                    doc_url: docUrl,
                  };
                }
                return fileState;
              });
            });
        }
      } catch (error) {
        console.error("Error uploading file:", error);

        setFileStates((prevFileStates: any) => {
          return prevFileStates.map((fileState: any, index: any) => {
            if (index === fileIndex) {
              return { ...fileState, error: true };
            }
            return fileState;
          });
        });

        setTimeout(() => {
          setFileStates((prev: any) =>
            prev.filter((_: any, idx: any) => idx !== fileIndex)
          );
          copilotStore?.setFileError("");
        }, 3000);
      }
    },
    [copilotStore]
  );

  return { uploadAttachment };
};
